import { createSelector } from 'reselect';
import { getDocument } from './index';

export const getIsOpenIntentionToSellDocumentModal = createSelector(
    [getDocument],
    document => document.isOpenIntentionToSellDocumentModal
);
